import React from 'react';
import { useResize } from '../../hooks';
import { SvgDiv, StyledDiv, StyledHeader, Wrapper, HamburguerWrapper  } from './header.styled';
import { MenuActions, MenuActionsMobile, HeaderLogo, Menu, Hamburguer } from '../'
import { store } from './../../effects/store'
import { setMenu, setMenuContent, setCurrentStep, setCurrentCollection, setCurrentGama } from './../../effects/actions'


 const HeaderComponent = ({ onVR, currentSite, isPlaying = false, muted }) => {

  const isMobile = useResize().isMobile;
 
  const onClickMenu = () => {
    let redirect = currentSite === "factory" ? "process" : "products"
    store.dispatch(setMenu(true))
    store.dispatch(setMenuContent(!isMobile ? redirect : null))
    store.dispatch(setCurrentStep("gama"))
    store.dispatch(setCurrentCollection(null))
    store.dispatch(setCurrentGama(null))
  }

  const renderSocialMedia = () => {
    const menuSocialMedia = isMobile ? <MenuActionsMobile onClickVR={() => onVR()} muted={muted} />
            : <MenuActions onClickVR={() => onVR()} muted={muted} />;

    return menuSocialMedia;
  }

  return (
    <React.Fragment>
      <Wrapper>
        <StyledHeader>
          <SvgDiv>
            {isPlaying && (
              <HamburguerWrapper onClick={() => onClickMenu()}>
                <Hamburguer />
              </HamburguerWrapper>
            )}
          </SvgDiv>
          <StyledDiv className="logo">
            <HeaderLogo />
          </StyledDiv>
          <StyledDiv className="menu-actions">
            {isPlaying && renderSocialMedia()}
          </StyledDiv>
        </StyledHeader>
        
      </Wrapper>
      <Menu />
    </React.Fragment>
   
  )
}

export default HeaderComponent;
